var map = {
	"./decidim/avatar-multiuser.png": 9955,
	"./decidim/brands/facebook.svg": 6763,
	"./decidim/brands/google.svg": 62882,
	"./decidim/brands/twitter-x.svg": 75971,
	"./decidim/cc-badge.png": 55393,
	"./decidim/decidim-logo.svg": 42065,
	"./decidim/default-avatar.svg": 9713,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 47911,
	"./decidim/icons.svg": 37456,
	"./decidim/pattern.png": 99699,
	"./decidim/placeholder-card-g.svg": 34480,
	"./decidim/placeholder-card-l.svg": 72603,
	"./decidim/placeholder.jpg": 42322,
	"./decidim/remixicon.symbol.svg": 12840,
	"./decidim/vendor/social-share-button/douban.svg": 73243,
	"./decidim/vendor/social-share-button/email.svg": 60020,
	"./decidim/vendor/social-share-button/facebook.svg": 65808,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 65924,
	"./decidim/vendor/social-share-button/hacker_news.svg": 80536,
	"./decidim/vendor/social-share-button/linkedin.svg": 53618,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 33467,
	"./decidim/vendor/social-share-button/pinterest.svg": 32498,
	"./decidim/vendor/social-share-button/reddit.svg": 70568,
	"./decidim/vendor/social-share-button/telegram.svg": 59901,
	"./decidim/vendor/social-share-button/tumblr.svg": 51738,
	"./decidim/vendor/social-share-button/twitter.svg": 12241,
	"./decidim/vendor/social-share-button/vkontakte.svg": 32347,
	"./decidim/vendor/social-share-button/wechat.svg": 61190,
	"./decidim/vendor/social-share-button/whatsapp.svg": 25502,
	"./decidim/vendor/social-share-button/x.svg": 32972,
	"./decidim/vendor/social-share-button/xing.svg": 43308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87039;